// extracted by mini-css-extract-plugin
export default {"detail":"detail_detail__6AKEh","pre":"detail_pre__9Q2Ew"};